'use strict';

// temporary - don't wan t to keep changing 2 index.js files during split

module.exports = Object.assign({}, require('./services/index'));